import { Shield, MapPin, Mail } from "lucide-react"
import Link from "next/link"

export function Footer() {
  const serviceAreas = [
    "Downtown",
    "La Jolla",
    "UTC",
    "Carlsbad",
    "Oceanside",
    "Escondido",
    "Chula Vista",
    "National City",
  ]

  return (
    <footer id="contact" className="bg-primary text-primary-foreground py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link href="/" className="flex items-center gap-2 mb-4">
              <Shield className="h-8 w-8" />
              <div className="flex flex-col leading-tight">
                <span className="text-lg font-bold">San Diego</span>
                <span className="text-sm font-semibold">HIPAA Compliance</span>
              </div>
            </Link>
            <p className="text-primary-foreground/90 text-sm mb-4 leading-relaxed">
              Local HIPAA compliance experts dedicated to protecting San Diego's healthcare providers and patients. We
              live here, work here, and care about our community.
            </p>
            <div className="flex items-center gap-2 text-sm">
              <Mail className="h-4 w-4" />
              <a href="mailto:hello@sandiegohipaacompliance.com" className="hover:underline">
                hello@sandiegohipaacompliance.com
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/90">
              <li>
                <Link href="/hipaa-audit-san-diego" className="hover:underline">
                  HIPAA Audits
                </Link>
              </li>
              <li>
                <Link href="/hipaa-training-san-diego" className="hover:underline">
                  Staff Training
                </Link>
              </li>
              <li>
                <Link href="/hipaa-consultant-san-diego" className="hover:underline">
                  Consulting
                </Link>
              </li>
              <li>
                <Link href="/hipaa-breach-response-san-diego" className="hover:underline">
                  Breach Response
                </Link>
              </li>
              <li>
                <Link href="/pricing" className="hover:underline">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/90">
              <li>
                <Link href="/san-diego-healthcare-hipaa" className="hover:underline">
                  HIPAA Guide
                </Link>
              </li>
              <li>
                <Link href="/blog" className="hover:underline">
                  Blog
                </Link>
              </li>
              <li>
                <Link href="/about" className="hover:underline">
                  About Us
                </Link>
              </li>
              <li>
                <Link href="/contact" className="hover:underline">
                  Contact
                </Link>
              </li>
              <li>
                <Link href="/privacy" className="hover:underline">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Service Areas */}
        <div className="border-t border-primary-foreground/20 pt-8 mb-8">
          <div className="flex items-center gap-2 mb-4">
            <MapPin className="h-5 w-5" />
            <h3 className="font-semibold">San Diego Service Areas</h3>
          </div>
          <div className="flex flex-wrap gap-3 text-sm text-primary-foreground/90">
            {serviceAreas.map((area, index) => (
              <span key={index}>
                {area}
                {index < serviceAreas.length - 1 && <span className="ml-3">•</span>}
              </span>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-primary-foreground/20 pt-8 text-center text-sm text-primary-foreground/90">
          <p>© {new Date().getFullYear()} San Diego HIPAA Compliance. All rights reserved.</p>
          <p className="mt-2">
            Powered by{" "}
            <a
              href="https://inventivehq.com"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-primary-foreground"
            >
              InventiveHQ
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}
